(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers', [
            'services.authenticatedUser',
            'recomModule'
        ]);
})();
